export const firebaseConfig = {
  apiKey: "AIzaSyBuvj_N6DUAkLFdvuCSUUZIwMlUv0qmQbI",
  authDomain: "vuetest-ed8b7.firebaseapp.com",
  databaseURL: "https://vuetest-ed8b7.firebaseio.com",
  projectId: "vuetest-ed8b7",
  storageBucket: "vuetest-ed8b7.appspot.com",
  messagingSenderId: "480058580905",
  appId: "1:480058580905:web:d54354295b73615e"
};